/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 * @param {number} value The number to clamp.
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 * clamp(-10, -5, 5) // -5
 * clamp(10, -5, 5) // 5
 */
export function clamp(value: number, lower: number, upper: number): number {
  return Math.min(Math.max(value, lower), upper);
}
